<template>
    <div id="About" class="page" data-page="faq">
        <appModal ref="appModalRef" :countries="DBCountries"></appModal>
        <appHeader bgColor="blue" @headerMenuClicked="menuClicked" page="about"></appHeader>
        <div class="main">
            <div class="main_inner">
                <section class="main_section">
                    <div class="section_content">
                        <h1 class="title_page text_title2">
                            FAQ
                        </h1>
                    </div>
                </section>

                <section class="main_section section_about">
                    <div class="section_content">
                        <div class="content_title">1. What is the Atlas of the Offshore World?</div>
                        <p class="text_p">The Atlas of the Offshore World is a global repository developed by the EU Tax Observatory and Skatteforsk – Centre for Tax Research. It provides research-based, reliable, up-to-date, and user-friendly information on global profit shifting, offshore financial and real estate wealth, and effective tax rates worldwide.</p>    
                        <p class="text_p">The Atlas aims to facilitate and promote democratic dialogue on global tax avoidance by providing detailed and accessible information. It serves as a tool for researchers, policymakers, and civil society to understand and address issues related to tax evasion and avoidance.</p>    
                        <p class="text_p">The Atlas is a joint initiative by the EU Tax Observatory and Skatteforsk – Centre for Tax Research, with financial support from Norway. It aims to inform scientific communities, civil society, and policymakers about global tax avoidance.</p>    
                        <br /><br />
                        <div class="content_title">2. How reliable is the data in the Atlas, and what methodologies are used?</div>
                        <p class="text_p">The data provided in the Atlas of the Offshore World is based on peer-reviewed academic research and official statistics from credible sources such as the OECD, national tax authorities, and international financial databases.</p>    
                        <p class="text_p">Each dataset is accompanied by detailed methodological notes that explain the assumptions, data sources, and calculation techniques used. These notes aim to ensure transparency, reproducibility, and scholarly rigor. Users can review and download these documents from the "Download data & methodology" section of the website.</p>    
                        <p class="text_p">While efforts are made to ensure accuracy, the Atlas acknowledges limitations due to data availability and possible underreporting in offshore activities. Nonetheless, the methodologies used are considered state-of-the-art in the field of international tax research.</p>    
                        <br /><br />
                        <div class="content_title">3. How often is the data updated?</div>
                        <p class="text_p">The datasets are periodically updated to reflect the most recent data and research findings. The last update was 14 November 2025</p>    
                        <br /><br />
                        <div class="content_title">4. Can I download the data and methodology?</div>
                        <p class="text_p">Yes, the Atlas provides complete annotated versions of the datasets along with detailed methodology notes for each series. These can be accessed and downloaded from the "Download data & methodology" section on the website.</p>    
                        <br /><br />
                        <div class="content_title">5. Is there a way to engage with the Atlas team for questions or feedback?</div>
                        <p class="text_p">Yes, you can send an email to <a href="mailto:info@atlas-offshore-world.org">info@atlas-offshore-world.org</a> with your query. The Atlas team will get in touch soon.</p>    
                    </div>
                </section>
            </div>
        </div>
        <appFooter></appFooter>
        <cookiesConsent></cookiesConsent>
    </div>
</template>

<script>
    import * as d3 from 'd3'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import Vue from 'vue'
    import * as UTILS from '~/commons/utils/index.js'
    import {_} from 'underscore'
    var slugify = require("underscore.string/slugify")
    var numberFormat = require('underscore.string/numberFormat')

    import appHeader from '~/components/appHeader.vue'
    import appFooter from '~/components/appFooter.vue'
    import appModal from '~/components/appModal.vue'
    import cookiesConsent from '~/components/cookiesConsent.vue'

    export default {
        components: {
            "appHeader": appHeader,
            "appFooter": appFooter,
            "appModal": appModal,
            "cookiesConsent": cookiesConsent
        },

        data: function () {
            return {
                isDataLoaded: false,
                DBCountries: [],
            }
        },

        created: function () {

        },

        mounted: function () {
            var self = this; 
            this.loadCountriesMetadata();
        },

        methods: {
            loadCountriesMetadata: function (){
                var self = this;

                UTILS.loadCountriesCSVData().then(function (callbackDBCountries){
                    self.DBCountries = JSON.parse(JSON.stringify(callbackDBCountries.dbCountries));
                }).catch(err => {
                console.log(err);
              });
            },

            openModal: function (modalType){
                this.$refs.appModalRef.openModal(modalType);
            },

            menuClicked: function (menuType){
                this.openModal(menuType)
            },
        },

        watch: {

        }
    }

</script>

<style lang="scss">
    @import "~assets/scss/_variables.scss";
    @import "~assets/scss/_browsers.scss";

    #About[data-page="faq"]{
        .content_title{
            margin-bottom: 20px;
        }
    }

    #About .main{
        background: #fff;
        .main_inner{
            .main_section{
                &.section_about{
                    padding: 50px 0 60px;
                    background: linear-gradient(180deg, #EEF1F6 0%, rgba(238, 241, 246, 0.00) 100%);
                }
            }
        }
    }

   
</style>


// WEBPACK FOOTER //
// pages/faq/index.vue